import { Injectable } from "@angular/core"
import { BehaviorSubject, Subject } from "rxjs"

@Injectable()
export class ConfirmLogoutDialogService {
    public confirmLogout = new Subject<any>();
    public observer: any = this.confirmLogout.asObservable();
    public data: any = {};

    show(args: any) {
        const loaderEl = document.getElementById("confirm-logout-dialog-static-backdrop");
        loaderEl.setAttribute("style", "display: block; z-index: 4000");
        loaderEl.classList.add("show");
        this.confirmLogout.next(args);
    }

    hide() {
        const loaderEl = document.getElementById("confirm-logout-dialog-static-backdrop");
        loaderEl.setAttribute("style", "display: none;");
        loaderEl.classList.remove("show");
    }

}